// extracted by mini-css-extract-plugin
export var alternate = "_1s-j";
export var black = "_1s-6";
export var blue = "_1s-f";
export var blueLight = "_1s-e";
export var brand = "_1s-8";
export var darkMode = "_1s-b";
export var error = "_1s-a";
export var gray = "_1s-5";
export var grayBlue = "_1s-d";
export var iconWrapper = "_1s-3";
export var inactive = "_1s-7";
export var indigo = "_1s-g";
export var orange = "_1s-i";
export var pink = "_1s-h";
export var primary = "_1s-0";
export var purple = "_1s-9";
export var success = "_1s-4";
export var warning = "_1s-c";
export var white = "_1s-1";
export var whiteSuccess = "_1s-2";